<div class="container">
  <div class="row">
    <div class="col-6">
      <span class="title">Filial</span>
      <div class="col-12 desc" *ngIf="listCompany.length > 0; else elseCompany">
        <div *ngFor="let company of listCompany">{{ company.companyName }}</div>
      </div>
        <ng-template #elseCompany>
          <div class="col-12 desc">Nenhum Selecionado</div>
        </ng-template>
    </div>



    <div class="col-6">
      <span class="title">Departamento</span>
      <div class="col-6 desc" *ngIf="listDepartament.length > 0; else elseDep">
        <div *ngFor="let dep of listDepartament">{{ dep.name }}</div>
      </div>
      <ng-template #elseDep>
        <div class="col-12 desc">Nenhum Selecionado</div>
      </ng-template>
    </div>

    <div class="col-6 col-sm-6">
      <span class="title">Cargo</span>
      <div class="col-12 desc" *ngIf="listRoles.length > 0; else elseRole">
        <div *ngFor="let role of listRoles">{{ role.name }}</div>
      </div>
      <ng-template #elseRole>
        <div class="col-12 desc">Nenhum Selecionado</div>
      </ng-template>
    </div>

    <div class="col-6 col-sm-6">
      <span class="title">Usuários específicos</span>
      <div class="col-12 desc"  *ngIf="classification.users.length > 0">
        <span class="col-12 desc">{{ listUsers()}}</span>
      </div>
    </div>
  </div>
